import { ErrorMessage, FieldArray, Form, Formik } from "formik";
import * as Yup from "yup";
import styles from './FilterComponent.module.scss'
import FormikControl from "../../../../components/formComponents/FormikControl";
import i18n from "i18next";
import { Box } from "@mui/material";
import Button from "../../../../components/buttons/Buttons";
import { useState } from "react";
import PropTypes from "prop-types";
import _ from 'lodash';
import { dateInputValidation } from "../../../../config/appConfig";


const FilterComponent = (props) => {
  const { setIsShowFilterOption, setFilterSearchValues, appliedfilter } = props;
  const [dateFilterIndex, setDateFilterIndex] = useState(-1);
  const initialFilter = _.isEmpty(appliedfilter) ? { rows: [{ fieldName: '', fieldValue: '' }] } : appliedfilter;
  const filterNameOptions = [
    { key: i18n.t("License plate"), value: i18n.t("License plate") },
    { key: i18n.t("VIN no"), value: i18n.t("VIN no") },
    { key: i18n.t("Make"), value: i18n.t("Make") },
    { key: i18n.t("Model"), value: i18n.t("Model") },
    { key: i18n.t("Dealer"), value: i18n.t("Dealer") },
    { key: i18n.t("100% OH"), value: i18n.t("100% OH  ") },
    { key: i18n.t("CH&GO"), value: i18n.t("CH&GO") },
    { key: i18n.t("BOIMP"), value: i18n.t("BOIMP") },
    { key: i18n.t("BOGAR"), value: i18n.t("BOGAR") },
    { key: i18n.t("Label5"), value: i18n.t("Label5") },
    { key: i18n.t("Adv. Status"), value: i18n.t("Adv. Status") },
    { key: i18n.t("Laatste bericht"), value: i18n.t("Laatste bericht") }
  ];
  const fieldValueYesNoOptions = [
    { key: i18n.t("Ja"), value: i18n.t("Ja") },
    { key: i18n.t("Nee"), value: i18n.t("Nee") }
  ];
  const fieldValueActiveInactiveOptions = [
    { key: i18n.t("Actief"), value: i18n.t("Actief") },
    { key: i18n.t("Inactief"), value: i18n.t("Inactief") }
  ];
  const dropdownOptionFields = [
    i18n.t("100% OH"),
    i18n.t("CH&GO"),
    i18n.t("BOIMP"),
    i18n.t("BOGAR"),
    i18n.t("Label5"),
    i18n.t("Adv. Status")
  ]

  const [filterNameOptionList, setFilterNameOptionList] = useState(filterNameOptions);

  const removeDuplicates = (a, b) => {

    b = b.filter(function (item) {
      for (let i = 0, len = a.length; i < len; i++) {
        if (a[i].fieldName.key === item.key) {
          return false;
        }
      }
      return true;
    });
    return b;
  }
  const getDropDownComponent = (values, index, setFieldTouched, setFieldValue, fieldKey) => {
    return (
      <Box>
        <FormikControl
          variant="filled"
          control="autocomplete"
          label="Field Value"
          options={_.isEqual(fieldKey, i18n.t("Adv. Status"))? fieldValueActiveInactiveOptions : fieldValueYesNoOptions}
          hiddenLabel
          id={`rows.${index}.fieldValue`}
          name={`rows.${index}.fieldValue`}
          size="small"
          placeholder={i18n.t("Select the value")}
          className="input-grp__box select"

          onChange={(e, value) => {
            setFieldTouched(`rows.${index}.fieldValue`, false);
            setFieldValue(`rows.${index}.fieldValue`, value);
          }}
          value={values?.rows[index]
            .fieldValue}

        />
        <ErrorMessage
          name={`rows.${index}.fieldValue`}
          component="div"
          className={styles.fieldError}
        />
      </Box>
    );
  }
  const getTextFieldComponent = (values, index, handleChange) => {
    return (
      <div>

        <FormikControl
          control="textfield"
          type="text"
          size="small"
          variant="filled"
          className={`input-grp__box`}
          label="Field Value"
          id="fieldValue"
          name={`rows.${index}.fieldValue.value`}
          placeholder={i18n.t(
            "Enter the value"
          )}
          onChange={handleChange}
          value={
            values.rows[index]
              .fieldValue?.value
          }
        />

        <ErrorMessage
          name={`rows.${index}.fieldValue`}
          component="div"
          className={styles.fieldError}
        />
      </div>
    );
  }
  const getDateComponent = (values, index, setFieldTouched, setFieldValue) => {
    return (
      <Box>
        <Box className={styles.dateFilterStyle}>
          <div>
            <FormikControl
              variant="filled"
              control="datepicker"
              hiddenLabel
              label={i18n.t("From date")}
              id={`rows.${index}.fieldValue.fromdate`}
              name={`rows.${index}.fieldValue.fromdate`}
              value={
                values.rows[index].fieldValue.fromdate

              }
              placeholderText={i18n.t(
                "From date"
              )}
              format={"DD-MM-YYYY"}
              onChange={(date, { customInput, isTyping }) => {
                let input = document.getElementById(
                  `rows.${index}.fieldValue.fromdate-datepicker`
                );

                setFieldTouched(
                  `rows.${index}.fieldValue.fromdate`,
                  true
                );

                if (!isTyping) {
                  setFieldValue(
                    `rows.${index}.fieldValue.fromdate`,
                    date.format()
                  ); // user selects the date from the calendar and no needs for validation.
                }
                if (!dateInputValidation(input, date)) {
                  return false;
                }

                setFieldValue(
                  `rows.${index}.fieldValue.fromdate`,
                  date?.format()
                );
                setFieldValue(
                  `rows.${index}.fieldValue.value`,
                  ""
                );
              }}
            />
          </div>

          <div>
            <FormikControl
              variant="filled"
              control="datepicker"
              hiddenLabel
              label={i18n.t("To date (inclusive)")}
              id={`rows.${index}.fieldValue.toDate`}
              name={`rows.${index}.fieldValue.toDate`}
              value={
                values.rows[index].fieldValue.toDate

              }
              placeholderText={i18n.t("Select To date")}
              format={"DD-MM-YYYY"}
              onChange={(date, { customInput, isTyping }) => {
                let input = document.getElementById(
                  `rows.${index}.fieldValue.toDate-datepicker`
                );

                setFieldTouched(
                  `rows.${index}.fieldValue.toDate`,
                  true
                );

                if (!isTyping) {
                  setFieldValue(
                    `rows.${index}.fieldValue.toDate`,
                    date.format()
                  ); // user selects the date from the calendar and no needs for validation.
                }
                if (!dateInputValidation(input, date)) {
                  return false;
                }

                setFieldValue(
                  `rows.${index}.fieldValue.toDate`,
                  date?.format()
                );
                setFieldValue(
                  `rows.${index}.fieldValue.value`, //for dummy sending to backend 
                  ""
                );
              }}
            />
          </div>

        </Box>
        <ErrorMessage
          name={`rows.${index}.fieldValue`}
          component="div"
          className={styles.fieldError}
        />
      </Box>
    )
  }
  const loadFieldComponent = (values, index, setFieldTouched, setFieldValue, handleChange) => {
    const fieldKey = values.rows[index].fieldName.key;
    if (_.isEqual(fieldKey, 'Laatste bericht')) {
      return getDateComponent(values, index, setFieldTouched, setFieldValue);
    } else if (_.includes(dropdownOptionFields, i18n.t(fieldKey))) {
      return getDropDownComponent(values, index, setFieldTouched, setFieldValue, fieldKey);
    } else {
      return getTextFieldComponent(values, index, handleChange);
    }
  }

  return (
    <Box className={styles.filterWrapper} data-testid="fieldcomptest">
      <Formik
        initialValues={initialFilter}
        validationSchema={Yup.object({
          rows: Yup.array().of(
            Yup.object({
              fieldName: Yup.object().required(i18n.t("Please select the name")),
              fieldValue: Yup.object().required(i18n.t('please fill the value'))
            })
          ),
        })}
        onSubmit={(values) => {
          setFilterSearchValues("", values);
        }}
      >
        {({ values, setFieldTouched, setFieldValue, validateForm, handleChange, handleSubmit, setTouched }) => (
          <Form>
            <Box>
              <FieldArray name="rows">
                {({ insert, remove, push }) => (
                  <div>
                    {values.rows.length > 0 &&
                      values.rows.map((row, index) => (
                        <div className={styles.row} key={row.fieldName}>
                          <div className={styles.col}>
                            <FormikControl
                              variant="filled"
                              control="autocomplete"
                              label="Field Name"
                              options={filterNameOptionList}
                              hiddenLabel
                              id={`rows.${index}.fieldName`}
                              name={`rows.${index}.fieldName`}
                              size="small"

                              placeholder={i18n.t("select the Name")}
                              className="input-grp__box select"

                              onChange={(e, value) => {
                                setFieldTouched(`rows.${index}.fieldName`, false);
                                setFieldValue(`rows.${index}.fieldName`, value);
                                if (value.key === 'Laatste bericht') {
                                  setDateFilterIndex(index)
                                }
                              }}
                              value={values.rows[index]
                                .fieldName}

                            />
                            <ErrorMessage
                              name={`rows.${index}.fieldName`}
                              component="div"
                              className={styles.fieldError}
                            />
                          </div>


                          {loadFieldComponent(values, index, setFieldTouched, setFieldValue, handleChange)
                          }
                          <div className={styles.col}>

                            <Box className={styles.buttonWrapper}>
                              <Button
                                title={"X"}
                                classList={styles.xbotton}
                                buttonType="muibtn-secondary-with-icon"
                                withIcon={true}

                                handleClick={() => remove(index)}
                              />
                            </Box>
                          </div>
                        </div>
                      ))}

                    <Box className={styles.footerFilterButtonContainer}>

                      <Button
                        type="button"
                        title="Add Filter"

                        buttonType="muibtn-secondary"
                        withIcon={false}
                        handleClick={async () => {
                          const errors = await validateForm();
                          if (Object.keys(errors).length === 0) {
                            const filtered = removeDuplicates(values.rows, filterNameOptions);
                            setFilterNameOptionList(filtered);
                            push({
                              fieldName: "",
                              fieldValue: "",
                            })
                          } else {
                            setTouched({
                              rows: values.rows.map(() => ({
                                fieldName: true,
                                fieldValue: true
                              }))
                            });
                          }

                        }
                        }
                      />

                      <Box className={styles.submitClearButtonWrapper}>
                        <Button
                          type="button"
                          title="Cancel"
                          iconStyle={styles.plusIcon}
                          buttonType="muibtn-secondary-with-icon"
                          withIcon={true}
                          handleClick={() => setIsShowFilterOption(false)}
                        />
                        <Button
                          title="Submit"
                          iconStyle={styles.plusIcon}
                          buttonType="muibtn-primary-with-icon"
                          withIcon={true}
                          type="submit"
                          isDisabled = {_.isEmpty(values.rows)}
                          handleClick={handleSubmit}

                        />
                      </Box>


                    </Box>


                  </div>
                )}
              </FieldArray>
            </Box>
            {/* <button type="submit">Submit</button> */}
          </Form>
        )}
      </Formik>
    </Box>
  );
};
export default FilterComponent;
FilterComponent.propTypes = {
  setIsShowFilterOption: PropTypes.any,
  setFilterSearchValues: PropTypes.func
};